module.exports = __webpack_public_path__ + "images/emoji/rage1.ee8d7bcb729da593738b.png";